import { render, staticRenderFns } from "./OVDetailRepuestosData.vue?vue&type=template&id=4d049ad0&scoped=true&lang=pug"
import script from "./OVDetailRepuestosData.vue?vue&type=script&lang=js"
export * from "./OVDetailRepuestosData.vue?vue&type=script&lang=js"
import style0 from "./OVDetailRepuestosData.vue?vue&type=style&index=0&id=4d049ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d049ad0",
  null
  
)

export default component.exports